/**
 * Main product page functionality
 * Handles product column quantity synchronization, product detail swiper carousel,
 * and subscription widget integration for product pages
 */

class productCol extends HTMLElement {
  constructor() {
    super();

    this.quantityInputElements = this.querySelectorAll('quantity-input input');

    this.quantityInputElements.forEach(element => {
      ['change', 'input'].forEach((inputEvent) => {
        element.addEventListener(inputEvent, (e) => this.handleValue(e.target.valueAsNumber));
      })
    });
  }

  /**
   * Handle the values of the quantity inputs
   * @param {Number} valueAsNumber 
   */
  handleValue(valueAsNumber) {
    this.quantityInputElements.forEach(element => element.value = valueAsNumber);
  }
  
}

if(!customElements.get('product-col')) {
  customElements.define('product-col', productCol);
}


// Swiper is imported already
class productDetailSwiper extends HTMLElement {
  constructor() {
    super();

    this.swiperElement = this.querySelector('[data-product-detail-swiper]');

    this.swiperOptions = {
      direction: 'horizontal'
    }

    this.init();
  }

  init() {
    window.addEventListener('load', (event) => {
      this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);
    });
    Fancybox.bind("[data-fancybox]", {
      animated: false,
      showClass: false
    });
  }
}

if(!customElements.get('product-detail-swiper')) {
  customElements.define('product-detail-swiper', productDetailSwiper);
}

// Seal reserves space with `.is-reserving` (shimmer placeholder) to avoid layout
// shift while its widget loads. Seal only signals success, never absence: for a
// product it decides has no subscription it injects nothing and fires no event,
// which would leave the placeholder stuck forever. `product.selling_plan_groups`
// is not a reliable gate (Seal attaches groups Liquid counts but renders no widget
// for), so resolve the placeholder client-side from Seal's actual behaviour.
(function () {
  var SEAL_WIDGET_TIMEOUT = 3000;

  function resolveSkeleton(el) {
    el.classList.remove('is-reserving');
  }

  // Widget painted -> drop the placeholder immediately.
  document.addEventListener('sealsubs:subscription_widget_created', function () {
    document
      .querySelectorAll('.sealsubs-target-element.is-reserving')
      .forEach(resolveSkeleton);
  });

  document
    .querySelectorAll('.sealsubs-target-element.is-reserving')
    .forEach(function (el) {
      // Clear the instant Seal injects anything, even if its event doesn't fire.
      var observer = new MutationObserver(function () {
        if (el.childElementCount > 0) {
          resolveSkeleton(el);
          observer.disconnect();
        }
      });
      observer.observe(el, { childList: true });

      // Nothing injected in time -> collapse so we don't leave an empty block.
      // CSS `.sealsubs-target-element:empty:not(.is-reserving)` zeroes the margin.
      setTimeout(function () {
        observer.disconnect();
        if (el.childElementCount === 0) {
          resolveSkeleton(el);
        }
      }, SEAL_WIDGET_TIMEOUT);
    });
})();

